import type { PropsWithChildren } from 'react';

export const TableTab = ({
  isActive,
  children,
}: PropsWithChildren<{ isActive?: boolean }>) => {
  return (
    <div
      className={`
        rounded-t-xl
        ${isActive && 'bg-white'}
        mb-[-16px] px-8 pb-8 pt-4
      `}
    >
      {typeof children === 'string' ? (
        <h3
          className={`
            text-2xl
            ${!isActive && 'text-gray-500'}
            m-0 font-bold
          `}
        >
          {children}
        </h3>
      ) : (
        children
      )}
    </div>
  );
};
